export default __webpack_public_path__ + "static/media/DarkSuscripcion.6add5124.svg";